import { Badge, IconButton, Pane, Table, Text, TextInputField, TrashIcon } from 'evergreen-ui';

const PRODUCT_IMAGE_BUCKET = process.env.REACT_APP_PRODUCT_IMAGE_BUCKET;
const CARD_IMAGE_BUCKET = process.env.REACT_APP_CARD_IMAGE_BUCKET;

const ConsumableRow = ({ consumable, index, isEditing, onQuantityChange, onRemove }) => {
  const isProduct = consumable.itemType === 'product';
  // Support both API formats: consumable.item (old) and consumable.product/single (new)
  const item = consumable.item || (isProduct ? consumable.product : consumable.single);

  return (
    <Table.Row key={`consumable-${consumable.id || index}`}>
      <Table.Cell flexBasis={60} flexShrink={0} flexGrow={0}>
        {isProduct ? (
          item?.thumbnail ? (
            <img
              src={`${PRODUCT_IMAGE_BUCKET}/thumb_${item.thumbnail}.jpg`}
              alt={item?.title || 'Product'}
              style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }}
            />
          ) : (
            <Pane width={40} height={40} background="tint2" borderRadius={4} />
          )
        ) : (
          item?.image ? (
            <img
              src={`${CARD_IMAGE_BUCKET}/${item.image}`}
              alt={item?.name || 'Card'}
              style={{ width: 40, height: 56, objectFit: 'cover', borderRadius: 4 }}
            />
          ) : (
            <Pane width={40} height={56} background="tint2" borderRadius={4} />
          )
        )}
      </Table.Cell>
      <Table.Cell flexBasis={100} flexShrink={0} flexGrow={0}>
        <Badge color={isProduct ? 'blue' : 'purple'}>
          {isProduct ? 'Product' : 'Single'}
        </Badge>
      </Table.Cell>
      <Table.Cell>
        <Pane>
          <Text fontWeight={500} display="block">
            {isProduct ? (item?.title || `Product #${consumable.itemId}`) : (item?.name || `Card #${consumable.itemId}`)}
          </Text>
          {isProduct && item?.sku && (
            <Text size={300} color="muted" display="block">{item.sku}</Text>
          )}
          {!isProduct && item?.expansion && (
            <Text size={300} color="muted" display="block">{item.expansion.name}</Text>
          )}
        </Pane>
      </Table.Cell>
      <Table.Cell flexBasis={100} flexShrink={0} flexGrow={0}>
        {isEditing ? (
          <TextInputField
            type="number"
            min={1}
            value={consumable.quantity}
            onChange={(e) => onQuantityChange(index, e.target.value)}
            marginBottom={0}
            width={80}
          />
        ) : (
          <Text>{consumable.quantity}</Text>
        )}
      </Table.Cell>
      <Table.Cell flexBasis={60} flexShrink={0} flexGrow={0}>
        {isEditing && (
          <IconButton
            icon={TrashIcon}
            intent="danger"
            onClick={() => onRemove(index)}
          />
        )}
      </Table.Cell>
    </Table.Row>
  );
};

export default ConsumableRow;
